import React from 'react';
import { Link } from '@planne-software/uni';
import { IconUsers } from '@tabler/icons-react';

import { useTranslate } from '@src/core/hooks';

import { VoucherSummaryCount, VoucherSummaryLabel, VoucherSummaryRoot } from './styles';
import { uniTypography } from '@src/fonts/typography/uniTypography';

export type VoucherSummaryCardProps = {
  total: number;
  onViewAll: () => void;
};

export const VoucherSummaryCard = (props: VoucherSummaryCardProps) => {
  const { total, onViewAll } = props;
  const { i18n } = useTranslate();

  return (
    <VoucherSummaryRoot data-testid='voucher-summary-card'>
      <VoucherSummaryLabel>
        <IconUsers size={20} aria-hidden />
        <VoucherSummaryCount>{i18n('checkout_confirmed_vouchers_count', { count: total })}</VoucherSummaryCount>
      </VoucherSummaryLabel>

      <Link
        data-testid='voucher-summary-view-all'
        component='button'
        type='button'
        underline='always'
        onClick={onViewAll}
        sx={{
          ...uniTypography('text-sm', 'semibold'),
        }}
      >
        {i18n('checkout_confirmed_vouchers_view_all')}
      </Link>
    </VoucherSummaryRoot>
  );
};

export default VoucherSummaryCard;
